import Select from "@base/Inputs/Select/Select"

export default Select;
